import { render, staticRenderFns } from "./OthersLike.vue?vue&type=template&id=51b72032&scoped=true&"
import script from "./OthersLike.vue?vue&type=script&lang=js&"
export * from "./OthersLike.vue?vue&type=script&lang=js&"
import style0 from "./OthersLike.vue?vue&type=style&index=0&id=51b72032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b72032",
  null
  
)

export default component.exports